function convertProductIdsToString(productIds) {
  // Map each productId to a string with "form_" prefix
  return productIds.map((id) => `form_${id}`);
}

function calculateSecondsFromDate(dateString) {
  // Parse the input date string
  const targetDate = new Date(dateString);

  // Get the current date and time
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const differenceInMs = targetDate - currentDate;

  // Convert milliseconds to seconds
  const differenceInSeconds = Math.floor(differenceInMs / 1000);

  return differenceInSeconds;
}

function calculateAndApplyPrices(productElement, discount) {
  const discountPercentage = Math.abs(parseFloat(discount));

  const originalPriceElement = productElement.querySelector(
    ".product__price--old",
  );
  const currentPriceElement = productElement.querySelector(
    "#product_price_current",
  );

  if (!currentPriceElement) {
    return { originalPrice: 0, finalPrice: 0 };
  }

  const basePriceRaw = productElement.dataset.globalCampaignBasePrice;
  const basePrice = basePriceRaw
    ? Number(basePriceRaw)
    : extractPrice(currentPriceElement);

  if (!basePrice) {
    return { originalPrice: 0, finalPrice: 0 };
  }

  if (!basePriceRaw) {
    productElement.dataset.globalCampaignBasePrice = String(basePrice);
    productElement.dataset.globalCampaignOldPriceHtml =
      currentPriceElement.innerHTML;
  }

  const finalPrice = basePrice * (1 - discountPercentage / 100);

  currentPriceElement.innerHTML =
    "KM" +
    (Math.ceil(finalPrice * 100) / 100).toFixed(2).toString().replace(".", ",");

  if (originalPriceElement && basePrice !== finalPrice) {
    originalPriceElement.classList.remove("product__price--old--hide");
    originalPriceElement.innerHTML =
      productElement.dataset.globalCampaignOldPriceHtml ||
      currentPriceElement.innerHTML;
  }

  return { originalPrice: basePrice, finalPrice };
}

function applyDiscountLabel(
  productElement,
  originalPrice,
  finalPrice,
  labelSelector,
  wrapperSelector,
  labelClass,
) {
  const discountPercentage = Math.round(
    ((originalPrice - finalPrice) / originalPrice) * 100,
  );
  const discountValue = `-${discountPercentage}%`;

  // We should not overwrite existing tags like "NOVO".
  // Create/update a dedicated tag for global campaign discount.
  const discountWrapper = productElement.querySelector(labelSelector);
  const existingCampaignTag = discountWrapper?.querySelector(
    "[data-global-campaign-tag]",
  );

  if (existingCampaignTag) {
    existingCampaignTag.innerHTML = discountValue;
    return;
  }

  const ensureWrapper = () => {
    if (discountWrapper) return discountWrapper;

    const productWrapper = productElement.querySelector(wrapperSelector);
    if (!productWrapper) {
      console.warn(
        `Element with selector "${wrapperSelector}" not found in product element.`,
      );
      return null;
    }

    const wrapper = document.createElement("div");
    wrapper.className = labelSelector.replace(".", ""); // Remove dot from class name
    productWrapper.appendChild(wrapper);
    return wrapper;
  };

  const wrapper = ensureWrapper();
  if (!wrapper) return;

  const discountTag = document.createElement("div");
  discountTag.className = labelClass;
  discountTag.setAttribute("data-global-campaign-tag", "true");
  discountTag.innerHTML = discountValue;
  wrapper.appendChild(discountTag);
}

function handleGlobalCampaignProducts(productList, discount) {
  const globalCampaignProducts = document.getElementById(
    "global_campaign_products",
  );

  productList.forEach((id) => {
    const productElement = document.getElementById(id);

    if (productElement) {
      //Change the price according to discount

      const { originalPrice, finalPrice } = calculateAndApplyPrices(
        productElement,
        discount,
      );

      //Calculate discounts
      applyDiscountLabel(
        productElement,
        originalPrice,
        finalPrice,
        ".card__discount-tags",
        ".pos--rel.card",
        "card__discount-tags__tag",
      );

      // Clone the element
      const clonedElement = productElement.cloneNode(true);

      // Append the cloned element to the #tik-tok-products div
      globalCampaignProducts.appendChild(clonedElement);
      productElement.remove();
    }
  });
}

function handleGlobalCampaignCollections(productList, discount) {
  if (productList.length > 0) {
    productList.forEach((id) => {
      const productElement = document.getElementById(id);

      if (productElement) {
        //Change the price according to discount

        const { originalPrice, finalPrice } = calculateAndApplyPrices(
          productElement,
          discount,
        );

        //Calculate discounts
        applyDiscountLabel(
          productElement,
          originalPrice,
          finalPrice,
          ".card__discount-tags",
          ".pos--rel.card",
          "card__discount-tags__tag",
        );
      }
    });
  } else {
    console.warn(`There are no products in campaign`);
  }
}

const __globalCampaignVariantIdCache = new Map();

async function fetchCollectionVariantFormIds(collectionHandle) {
  if (!collectionHandle) return [];
  if (__globalCampaignVariantIdCache.has(collectionHandle)) {
    return __globalCampaignVariantIdCache.get(collectionHandle);
  }

  const fetchPage = async (page) => {
    const url = `/collections/${encodeURIComponent(
      collectionHandle,
    )}?view=wpd_collection_data&page=${page}`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Failed to fetch ${url}: ${res.status}`);
    return JSON.parse(await res.text());
  };

  const first = await fetchPage(1);
  const totalPages = Number(first.totalPages || 1);

  const variantIds = new Set();
  const collect = (payload) => {
    const items = Array.isArray(payload.productItems)
      ? payload.productItems
      : [];
    items.forEach((item) => {
      const id = item?.productDefaultVariantId;
      if (id) variantIds.add(String(id));
    });
  };

  collect(first);
  for (let page = 2; page <= totalPages; page += 1) {
    const payload = await fetchPage(page);
    collect(payload);
  }

  const formIds = Array.from(variantIds).map((id) => `form_${id}`);
  __globalCampaignVariantIdCache.set(collectionHandle, formIds);
  return formIds;
}

async function applyGlobalCampaignDiscounts() {
  const campaign = window.__GlobalCampaignConfig?.campaign;
  if (!campaign?.collections?.length) return;

  const now = Date.now();
  const start = campaign.startDate ? new Date(campaign.startDate).getTime() : 0;
  const end = campaign.endDate ? new Date(campaign.endDate).getTime() : 0;
  if (start && now < start) return;
  if (end && now > end) return;

  for (const entry of campaign.collections) {
    try {
      const ids = await fetchCollectionVariantFormIds(entry.handle);
      // If global campaign grid is present, move discounted items there (shop-all behavior).
      if (document.getElementById("global_campaign_products")) {
        handleGlobalCampaignProducts(ids, entry.discount);
      } else {
        handleGlobalCampaignCollections(ids, entry.discount);
      }
    } catch (e) {
      console.warn(e);
    }
  }
}

window.applyGlobalCampaignDiscounts = applyGlobalCampaignDiscounts;

function extractPrice(priceElement) {
  return parseFloat(
    priceElement.textContent.replace(/[^0-9,.-]+/g, "").replace(",", "."),
  );
}

function startCountdown(time, counterId) {
  const counterDiv = document.getElementById(counterId);

  if (!counterDiv) {
    console.error(`Element with id "${counterId}" not found.`);
    return;
  }

  // Function to update the counter every second
  const countdownInterval = setInterval(() => {
    if (time >= 0) {
      // Calculate days, hours, minutes, and seconds
      const days = Math.floor(time / (24 * 3600));
      const hours = Math.floor((time % (24 * 3600)) / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;

      // Format and update the counter div
      counterDiv.textContent = `${days}:${hours < 10 ? "0" : ""}${hours}:${
        minutes < 10 ? "0" : ""
      }${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

      // Decrement the time
      time--;
    } else {
      // Clear the interval when countdown is finished
      clearInterval(countdownInterval);
      counterDiv.textContent = "Time's up!";
    }
  }, 1000);
}

function startDailyCountdown(dailyTimeStr, endDateStr, counterId) {
  const counterDiv = document.getElementById(counterId);
  if (!counterDiv) return;

  const finalDeadline = new Date(endDateStr).getTime();

  let targetHour, targetMinute;
  if (dailyTimeStr) {
    [targetHour, targetMinute] = dailyTimeStr.split(":").map(Number);
  }

  const countdownInterval = setInterval(() => {
    const now = new Date();
    const nowTime = now.getTime();

    if (nowTime >= finalDeadline) {
      clearInterval(countdownInterval);
      counterDiv.textContent = "Time's up!";
      return;
    }

    let targetTime;

    if (dailyTimeStr) {
      let nextDailyGoal = new Date();
      nextDailyGoal.setHours(targetHour, targetMinute, 0, 0);

      if (nowTime >= nextDailyGoal.getTime()) {
        nextDailyGoal.setDate(nextDailyGoal.getDate() + 1);
      }

      targetTime = nextDailyGoal.getTime();

      if (targetTime > finalDeadline) {
        targetTime = finalDeadline;
      }
    } else {
      targetTime = finalDeadline;
    }

    let diffInSeconds = Math.floor((targetTime - nowTime) / 1000);

    if (diffInSeconds >= 0) {
      const days = Math.floor(diffInSeconds / (24 * 3600));
      const hours = Math.floor((diffInSeconds % (24 * 3600)) / 3600);
      const minutes = Math.floor((diffInSeconds % 3600) / 60);
      const seconds = diffInSeconds % 60;

      const format = (num) => (num < 10 ? "0" + num : num);

      let displayDays = days > 0 ? days + "d " : "";

      counterDiv.textContent = `${displayDays}${format(hours)}:${format(
        minutes,
      )}:${format(seconds)}`;
    }
  }, 1000);
}
